<ng-container *ngIf="display$ | async as display">
  <section [class.open]="display === 'open'" (click)="close()">
    <div (click)="$event.stopPropagation()">
      <h1>Something went wrong</h1>
      <p> {{ error }} </p>
      <hr>
      <div class="actions">
        <div class="other">
          <button class="custom-btn cancel" (click)="close()">Okay</button>
        </div>
      </div>
    </div>
  </section>
</ng-container>
